export const i18nKeyPrefix = 'MAIN-SEARCH'
